import React, { useEffect, useState } from "react";
import Brand from "../../components/Brands/Brand";
import SearchInput from "../../components/Home/SearchInput/SearchInput";
import { GoHomeFill } from "react-icons/go";
import OfferProductCard from "../../components/OfferProductCard/OfferProductCard";
import axios from "axios";
import { BASE_URL } from "../../constant/api";
import { useLocation, useParams } from "react-router-dom";

const Brands = () => {
  const { id } = useParams(); // Get the brand ID from the URL
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState(""); // Search query state
  const location = useLocation();
  const { brand } = location.state || {}; // Retrieve the passed brand data

  // Fetch products by brand ID
  const fetchOrderDetails = async () => {
    try {
      // const token = localStorage.getItem("token");
      // const headers = { Authorization: `Token ${token}` };
      const response = await axios.get(`${BASE_URL}/products/brand/${id}/`, );
      setProducts(response.data?.Data || []); // Assuming the data is inside `Data`
    } catch (error) {
      console.error("Error fetching order details:", error);
    } finally {
      setLoading(false);
    }
  };

  // Call fetchOrderDetails when `id` changes
  useEffect(() => {
    if (id) {
      fetchOrderDetails();
    }
  }, [id]);

  // Handle search query change
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  // Filter products based on search query
  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="container mx-auto border-t-2">
      {/* Banner Section */}
      <div className="relative p-8 w-full h-auto">
      <img
          src={brand?.brand_banner || "/images/banner1.jpg"} // Use brand image if available
          alt={brand?.brandname || "Offer Banner"}
          className="w-screen  md:h-[300px] object-fill rounded-lg"
        />
      </div>

      {/* Search Section */}
      <div className="mr-3">
        <SearchInput
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search product..."
          head=""
          icon={<GoHomeFill />}
        />
      </div>

      {/* Brands Section */}
      <div className="p-4">
        <Brand />
      </div>

      {/* Products Section */}
      <div className="p-8">
        {loading ? (
          <p className="text-center text-gray-500">Loading products...</p>
        ) : filteredProducts.length > 0 ? (
          <OfferProductCard products={filteredProducts} /> 
        ) : (
          <p className="text-center text-gray-500">No products found.</p>
        )}
      </div>
    </div>
  );
};

export default Brands;


